
import React, { Component } from 'react';
import { postJson } from '../../helpers/RequestsHelper';

class Authorization extends Component {


  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.redirectToLogin()
  }

  async redirectToLogin() {
    const queryParams = new URLSearchParams(window.location.search)
    const state = queryParams.get("state")
    const result = await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/oauth/appcode", { state })
    if (state === result.state) {
      window.location = "http://127.0.0.1:51777?code=" + result.code + "&state=" + result.state
    }
  }

  render() {
    return ""
  }

}

export default Authorization